var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollGridContainer",staticClass:"absolute inset-0 overflow-hidden"},[_c('div',{ref:"scrollGrid",staticClass:"yoyo h-full w-full",staticStyle:{"transform":"translate(-0%,0)","will-change":"transform"}},[_vm._t("grid-background"),_c('div',{ref:"gridContainer",staticClass:"absolute inset-0"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }